import { useEffect, useState } from "react";

const useValidate = (
  value: unknown,
  validate?:
    | ((value: unknown | string) => string | undefined | Promise<string | undefined>)
    | ((value: string) => string | undefined)
    | Array<(value: unknown) => (string | undefined) | Promise<string | undefined>>,
  errorMessage?: string
) => {
  const [error, setError] = useState<undefined | string>(undefined);

  useEffect(() => {
    const validateFunc = async () => {
      if (validate) {
        if (Array.isArray(validate)) {
          const errors: Array<string> = [];
          await Promise.all(
            validate.map(async (validator) => {
              const msg = await validator(value);
              if (msg) {
                errors.push(msg);
              }
            })
          );
          setError(errors[0]);
        } else {
          const err = await validate(value as string);
          setError(err);
        }
      }
    };
    validateFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, JSON.stringify(validate), errorMessage]);
  return error;
};

export default useValidate;
